var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"models"},[_c('TextTable',{attrs:{"all_data":_vm.all_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }